import { InjectionToken } from '@angular/core';

export interface ToastAction {
  label: string;
  handler: () => void;
}

export type ToastType = 'success' | 'warning' | 'error' | 'info' | 'default';

export type ToastPosition =
  | 'top-left'
  | 'top-center'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-center'
  | 'bottom-right';

export interface ResponsiveToastPosition {
  mobile: ToastPosition;
  desktop: ToastPosition;
}

export interface NttToastGlobalConfig {
  type?: ToastType;
  duration?: number;
  position?: ToastPosition | ResponsiveToastPosition;
  dismissible?: boolean;
  pauseOnHover?: boolean;
  verticalOffset?: number;
  horizontalOffset?: number;
}

export const NTT_TOAST_DEFAULT_CONFIG: Required<NttToastGlobalConfig> = {
  type: 'default',
  duration: 3000,
  position: { mobile: 'top-center', desktop: 'bottom-left' },
  dismissible: true,
  pauseOnHover: true,
  verticalOffset: 64,
  horizontalOffset: 16,
};

export const NTT_TOAST_CONFIG = new InjectionToken<NttToastGlobalConfig>(
  'NTT_TOAST_CONFIG',
  {
    providedIn: 'root',
    factory: () => ({}),
  },
);
